import React from 'react';
import Globalize from 'globalize';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../public/css/barri.css';
import ReactGA from 'react-ga';
import { browserHistory } from 'react-router';
import Iframe from 'react-iframe'

var connect = require('react-redux').connect;

Globalize.load(
  require("cldr-data/main/en/ca-gregorian.json"),
  require('cldr-data/main/en/timeZoneNames.json'),
  require('cldr-data/main/en/numbers.json'),
  require('cldr-data/main/en/currencies.json'),
  require('cldr-data/main/es/ca-gregorian.json'),
  require('cldr-data/main/es/timeZoneNames.json'),
  require('cldr-data/main/es/numbers.json'),
  require('cldr-data/main/es/currencies.json'),
  require('cldr-data/supplemental/currencyData.json'),
  require('cldr-data/supplemental/plurals.json'),
  require('cldr-data/supplemental/likelySubtags.json'),
  require('cldr-data/supplemental/timeData.json'),
  require('cldr-data/supplemental/weekData.json')
);
Globalize.locale("es");
Globalize.loadMessages(require('../files/en.json'));

function logPageView() {
  if (typeof window !== 'undefined') {
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
  } 
}

class TransactionTracker extends React.Component {

  constructor(props) {
    super(props);
    let lang = 'es';
    this.state = { locale: this.props.params.locale || lang };
    this.handleLocaleChange = this.handleLocaleChange.bind(this);
  }

  handleLocaleChange(language, fromUrl) {
    this.setState({
      locale: language
    });
    this.changeLocaleFromServer(language, fromUrl);
  }

  changeLocaleFromServer(language, fromUrl) {
    $.ajax({
      url: '/api/localeApp',
      type: 'POST',
      dataType: 'json',
      data: { idLocale: language },
      cache: false,
      success: function (data) {
        // this.setState({ locale: data });
        this.props.setLanguage(data.locale);
        if (fromUrl)
          this.removeQuery("loc")
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  }

  removeQuery(...queryNames) {
    const location = this.props.location;
    queryNames.forEach(q => {
      delete location.query[q]
    }
    );
    browserHistory.push(location);
  }

  componentDidMount() {
    ReactGA.initialize('UA-98389131-1');

    window.addEventListener('message', (event) => {
      const { action, data } = event.data || {};
      if (action === 'share' && navigator.share) {
        navigator.share(data)
          .then(() => console.log('Compartido desde el padre'))
          .catch((err) => console.error('Error al compartir desde el padre:', err));
      } else {
        console.log('navigator.share no disponible o acción no reconocida');
      }
    });

    let queryParams = this.props.location && this.props.location.query;
    if (queryParams.loc && (queryParams.loc == "es" || queryParams.loc == "en") && queryParams.loc != this.props.locale) {
      this.handleLocaleChange(queryParams.loc, true);
    }else if(queryParams.loc == this.props.locale){
      this.removeQuery("loc");
    }
  }

  obtenerParametrosURL() {
    //var urlParams = new URLSearchParams(this.props.location.search);

    if (typeof window !== 'undefined') {
      console.info('Window defined')
      let search = window.location && window.location.search || '';
      var value = search.split('value=')[1]
      console.log('value: ', value)
      return value;
    }
    return ''
  }

  obtenerEnv() {
    if (typeof window !== 'undefined') {
      console.info('Window defined')
      let hostname = window.location && window.location.hostname || '';
      if (hostname && (hostname.includes('barriqa') || hostname.includes('localhost'))) {
        return 'test'
      }
    }
    return 'prod'
  } 

  render() {
    let lang = this.props.locale;
    let slang = 'en-US';
    if (lang == 'es') slang = 'es-MX'

    let value = this.obtenerParametrosURL();
    let env = this.obtenerEnv();

    let url = '';
    //value from querystring

    if (env == 'prod') {
    url = "https://www.barrimoneytransfer.com/transactionTrack?value=" + value;
    }

    if (env == 'test') {
    url = "https://bmtqa.barrigroup.com/transactionTrack?value=" + value;
    }

    return (
      <div>
        <style>{` #page-top {
          padding-top: 0;
        } `}</style>
        <Iframe url={url}
          id='miIFrame'
          width="100%"
          height="100%"
          display="block"
          frameBorder={0}
          position="fixed"
          style={{ padding:0, border:0, marging: 0 }} />
      </div> 
    );
  }
}

const AppComponentState = function (state) {
  var stateJSON = JSON.stringify(state).replace(/<\/script/g, '<\\/script').replace(/<!--/g, '<\\!--');
  return {
    initialState: "window.__INITIAL_STATE__ = " + stateJSON,
    locale: state.locale
  }
}

const AppCmpDispatch = (dispatch) => {
  return {
    setLanguage: function (lang) {
      dispatch({
        type: 'set_language',
        lang: lang
      })
    }
  }
}

TransactionTracker = connect(
  AppComponentState,
  AppCmpDispatch
)(TransactionTracker)

module.exports = TransactionTracker


// WEBPACK FOOTER //
// ./js/transactionTracker.js